import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { useSelector } from "react-redux";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { resetSamithi_MembersToInit, setSamithi_MembersMessage } from "redux/actions";
import { Row, Button, Card, Col, Form, InputGroup } from "react-bootstrap";
import { Constant } from "template/Constant";
import ConfirmationModal from "template/ConfirmationModal";
import { deleteSamithi_Members } from "services/samithi_membersService";
import vibhag from "../../data/vibhag.json";
import { Link } from "react-router-dom";
import jillas from "../../data/jilla.json";
import nagars from "../../data/nagar.json";
import upamandal from "../../data/upamandal.json";
import basti from "../../data/basti.json";
import baseurl from 'baseurl';
import { useFormik } from "formik";
import gramam from "../../data/gramam.json";
import styled from "styled-components";
import { APIService } from "services";
import {
  useParams
} from "react-router-dom";
import { log } from "console";



const AddButton = styled(Button)`
  @media (max-width: 576px) {
    span.text {
      display: none;
    }
  }
`;



const Dropdown = styled.select`
  @media (max-width: 576px) {
    height: 53px;
    display: flex;
  }
`;

const inputgroup = {
  width: "100%",
};

type Props = {
  hideShowForm: (action) => void;
  handleRowEdit: (row) => void;
  // getData: (page, pageSize, searchKey) => void;
};
interface Member {
  added_occation: string; // Adjust the type if 'added_occation' has a different type
  // Add other properties as needed
}

export const Samithi_MembersTable: React.FC<Props> = ({ hideShowForm, handleRowEdit }) => {
  const dispatch = useAppDispatch();
  const [search, setSearch] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [rowData, setRowData] = useState(undefined);
  const rData = useSelector((state: RootState) => state.samithi_members);
  const [active, setActive] = useState(0);

  // console.log("rData", rData);


  var jsonArray1 = upamandal;
  var jsonArray2 = basti;
  jsonArray1 = jsonArray1.concat(jsonArray2);


  const handleRowDeleteClick = (row) => {
    let log_member_id = localStorage.getItem("log_member_id");
    let log_member_name = localStorage.getItem("log_member_name");
    let log_mobile_num = localStorage.getItem("log_mobile_num");

    console.log("154rowData", row)
    console.log("log_member_id", log_member_id)
    if (log_member_id == "undefined" && log_member_id == null) {
      log_member_id = "0";
    }
    console.log("created_by", row.created_by)
    console.log("log_member_id", log_member_id)
    if (parseInt(row.created_by) === parseInt(log_member_id)) {
      if (window.confirm("You are permanently deleting the data of \"" + row.name + "\". \nData can not be recovered. \nAre you sure?")) {
        // console.log("148rowData",log_member_id)
        const response = APIService.api().post("/samithi_members/delete", { "samithi_member_id": row.samithi_member_id })
        if (response) {
          // dispatch(resetSurvey_ResultsToInit());
          console.log("response86", response)
          alert("\"" + row.name + "\" details has been deleted successfully");
          window.location.reload()
        } else {
          alert("Some error occured!");
        }
      } else {
        //text = "You canceled!";
      }


    }
    else {
      alert("Details of this person have been entered by \n\nName   : " + row.member_name + " \nMobile : " + row.mobile_number + "\n\nOnly he has the rights to delete. Contact him ");
    }
    console.log("82created_byin table", row.created_by)
  }

  const handleRowSelection = (row) => {
    // console.log(row); // Row Selection Functionality can be written here
  }
  const handleAddButtonClick = () => {
    dispatch(setSamithi_MembersMessage(''));
    hideShowForm('add');
  }
  const editbuttonStyle = {
    backgroundColor: '#4e73df',
    color: 'white',
    padding: '10px',
    borderRadius: '5px'
  };

  const deletebuttonStyle = {

    color: '#e74a3b',
    padding: '10px',
    borderRadius: '5px'
  };

  const dropdownstyle = {
    borderColor: 'black',
    backgroundImage: "none",

  }

  const responsivefordropdowns = {
    height: "53px",
    width: "100%",
    display: "inline-block",
  }



  const designationlevelId = localStorage.getItem("desig_level_id");
  const vibahgId = localStorage.getItem("vibhag_id");
  const zillId = localStorage.getItem("zill_id");
  const nagarkhandId = localStorage.getItem("nagar_khanda_id");
  const upamandabastiId = localStorage.getItem("upamandal_basti_id");

  // console.log("nagarkhandId", nagarkhandId);

  console.log("126upamandabastiId", upamandabastiId);


  const iValue = {
    desig_level_id: localStorage.getItem('desig_level_id'),
    vibhag_id: 0,
    zill_id: 0,
    nagar_khanda_id: 0,
    upamandal_basti_id: 0,
    gramam_id: 0
  };
  const shouldHideDeleteButton = () => {
    const designationId = localStorage.getItem('designation_id');

    if (designationId && parseInt(designationId) === 3) {
      return true; // Hide the button
    }

    return false; // Show the button
  };




  const { id } = useParams();

  const [memebersList, setMemberslist] = useState([{}]);
  useEffect(() => {
    console.log("15bastiid", id)
    let gramamBasthiType = localStorage.getItem("basti_gramam_type")
    console.log("184basthigrmamtype", gramamBasthiType);
    let payload;
    if (gramamBasthiType === "basti") {
      payload = {
        type: "basti",
        type_id: id,
      };
      localStorage.setItem("basthi_id", id)
    }
    else {
      payload = {
        type: "gramam",
        type_id: id,
      };
      localStorage.setItem("gramam_id", id)
    }
    APIService.api().post("https://lhac.lokahitam.net/api/v1/samithi_members/searchWithFields", payload).then((response) => {
      //  console.log("22gramamsresponse",response) https://lhac.lokahitam.net/api/v1/
      // live url https://lhac.lokahitam.net/api/
      let vibhagData = response.data.membersList
      setMemberslist(vibhagData)
    }).catch((err) => {
      console.log(err)
    })
  }, [1000]);

  const [hideEditButton, setHidebutton] = useState(false)

  const shouldHideEditButton = () => {
    let filteredOccation = memebersList.filter((item: Member) => item.added_occation === "RAM");
    console.log("filteredOccation", filteredOccation);
    if (filteredOccation.length > 0) {
      return true;
    } else {
      return false;
    }
  };


  console.log("SamithiMembers Data", memebersList);

  const columns = [
    {
      name: '',
      button: true,
      cell: (row) => (
        row.added_occation === "RAM" ? (
          <Button variant="link" className="btn-sm" style={{ width: "50px" }} onClick={() => handleRowEdit(row)}>Edit</Button>) : null)
    }
    ,
    { name: 'SNo', selector: row => row.sequencenumber, sortable: true, width: "70px" },
    { name: 'Bhadyatha', selector: row => row.bhadyatha_name, sortable: true, wrap: true },
    // {
    //     name: 'Status',
    //     button: true,
    //     cell: (row) => <Button variant="link" className="btn-sm" style={{ color: row.status == 1 ? "green" : "red" }} onClick={() => handleRowDeleteClick(row)}>{row.status == 1 ? "Active" : "Inactive"}</Button>,
    // },
    { name: 'Full Name', selector: row => row.name, sortable: true, wrap: true },
    //  {name: 'Surname', selector: row => row.surname, sortable: true},
    { name: 'Father', selector: row => row.father_name, sortable: true, wrap: true },
    { name: 'Mobile', selector: row => row.mobile, sortable: true },
    { name: 'Age', selector: row => row.age, sortable: true, width: "70px" },
    { name: 'Occupation', selector: row => row.occupation_name, sortable: true, wrap: true },
    // {name: 'House No', selector: row => row.rev_addrs1, sortable: true},
    // {name: 'Street Name', selector: row => row.rev_addrs2, sortable: true},
    // {name: 'Village Name/Locality', selector: row => row.rev_addrs3, sortable: true},
    // { name: 'Village', selector: row => row.rev_addrs3, sortable: true },
    // { name: 'Mandal', selector: row => row.rev_mandal, sortable: true },

    // { name: 'Vibhag', selector: row => row.vibhag_name, sortable: true },
    //  { name: 'Zilla', selector: row => row.zilla_name, sortable: true },
    // { name: 'Surname', selector: row => row.surname, sortable: true },
    // { name: 'Father Name', selector: row => row.father_name, sortable: true },
    // { name: 'Nagar/Khanda Name', selector: row => row.nagar_khanda_name, sortable: true },
    // {name: 'Basti/Gramam', selector: row => row.is_basti_gramam, sortable: true, wrap: true},
    // {name: 'Basthi Name', selector: row => row.basti_name, sortable: true},
    { name: 'ADDED OCCATION', selector: row => row.added_occation, sortable: true, wrap: true },

    { name: 'Address', selector: row => row.address, sortable: true, wrap: true },
    { name: 'Pincode', selector: row => row.pincode, sortable: true },
    { name: 'Lokahitam', selector: row => row.lokahitam, sortable: true, wrap: true },
    { name: 'Filled By', selector: row => row.member_name, sortable: true, wrap: true },
    {
      name: '',
      button: true,
      cell: (row) => (
        shouldHideDeleteButton() ? null :
          <Button variant="link" className="btn-sm" style={deletebuttonStyle} onClick={() => handleRowDeleteClick(row)}>Delete</Button>
      ),
    }
    //   // {name: 'modified_by', selector: row => row.user_id, sortable: true},

  ];


  let nagar_khandaId = localStorage.getItem('nagar_khanda_id')
  let jilla_id = localStorage.getItem("jilla_id")
  // console.log("210nagar_khandaId",nagar_khandaId)
  let vibhag_id = localStorage.getItem("vibhag_id")
  let upamandal_basthi_id = localStorage.getItem("upamandal_basthi_id")
  // console.log("213upamandal_basthi_id",upamandal_basthi_id)
  let vibhagName = localStorage.getItem('vibhag_name')
  let jillaName = localStorage.getItem('zilla_name')
  let nagarKhandaName = localStorage.getItem('nagar_khanda_name')
  let upMandalName = localStorage.getItem('upamandal_name')
  let gramamName = localStorage.getItem('gramam_name')
  // console.log("44upMandalNamegramamspage",upMandalName)
  let bastiName = localStorage.getItem('basti_name')
  // console.log("44upbastiNamegramamspage",upMandalName)
  let DesignationId = parseInt(localStorage.getItem("desig_level_id"))

  return (
    <form >
      <Card className="shadow mb-4">
        <nav aria-label="breadcrumb">

          <ol className="breadcrumb" >


            {(DesignationId === 1 || DesignationId === 2) &&

              <li className="breadcrumb-item" ><Link to="/vibhagreports" style={{ color: "#194380" }}>{vibhagName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3) &&

              (vibhag_id != "undefined" && vibhag_id && vibhag_id != "null") &&
              <li className="breadcrumb-item" ><Link to={'/jillareports/' + vibhag_id} style={{ color: "#194380" }}>{jillaName}</Link></li>


            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4) &&
              <li className="breadcrumb-item"><Link to={'/nagarkhandareports/' + jilla_id} style={{ color: "#194380" }}>{nagarKhandaName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4
              || DesignationId === 5) &&
              (upMandalName != "undefined" && upMandalName && upMandalName != "null") &&
              <li className="breadcrumb-item" ><Link to={"/upmandalbasthireports/" + nagar_khandaId} style={{ color: "#194380" }}>{upMandalName}</Link></li>

            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4
              || DesignationId === 5 || DesignationId === 6) &&
              (gramamName != "null" && gramamName != "undefined" && gramamName) &&
              <li className="breadcrumb-item" ><Link to={"/gramamreports/" + upamandal_basthi_id} style={{ color: "#194380" }}>{gramamName}</Link></li>
            }
            {(DesignationId === 1 || DesignationId === 2 || DesignationId === 3 || DesignationId === 4
              || DesignationId === 5) &&
              (bastiName != "undefined" && bastiName != "null") &&
              <li className="breadcrumb-item" ><Link to={"/upmandalbasthireports/" + nagar_khandaId} style={{ color: "#194380" }}>{bastiName}</Link></li>
            }
          </ol>
        </nav>
        <Card.Header className="py-3">
          <h6 className="m-0 font-weight-bold" style={{ color: "#194380" }}>
            {gramamName != "undefined" && gramamName != "undefined" && gramamName != "null" &&
              <span style={{ color: '#fd803a' }}>{gramamName}</span>
            }
            {bastiName != "undefined" && bastiName != "null" &&
              <span style={{ color: '#fd803a' }}>
                {bastiName}</span>
            }
            &nbsp;- సేకరించిన చిరునామాల సూచి ( <span style={{ color: '#fd803a' }}>Total-{memebersList.length} Addresses  </span> )
            <Button variant="light" className="btn-circle btn-sm ml-2"><i className="fa fa-refresh"></i></Button>
            <AddButton className="btn-icon-split float-right" onClick={handleAddButtonClick}>
              <span className="icon text-white-50" style={{ backgroundColor: "#194380", borderColor: "#194380" }}>
                <i className="fas fa-add" style={{ backgroundColor: "#194380", borderColor: "#194380" }}></i>
              </span>
              <span className="text" style={{ backgroundColor: "#194380", borderColor: "5px Solid #194380" }}>Add New Address</span>
            </AddButton></h6>

        </Card.Header>
        <Card.Body>


          {memebersList && memebersList.length ? (
            <div className="table-responsive">
              <DataTable
                // selectableRows={true}
                // onSelectedRowsChange={handleRowSelection}
                // paginationPerPage={Constant.defaultPageNumber}
                // paginationRowsPerPageOptions={Constant.paginationRowsPerPageOptions}
                columns={columns}
                data={memebersList}
                // onChangeRowsPerPage={handlePerRowsChange}
                // paginationTotalRows={rData.totalCount}
                className="table table-bordered"
              // pagination
              // noDataComponent="ఈ సమితి లో సభ్యులు ఇంకా జాయిన్ అవలేదు"
              // paginationServer
              // onChangePage={handlePageChange}
              />
              {/* </DataTable> */}
            </div>
          ) : (
            <div className=" mb-0 font-weight-bold text-gray-800" style={{ textAlign: "center" }}>
              Sorry no address collected till now. Please collect some addresses and add them here.
            </div>
          )}
        </Card.Body>
        {/* <ConfirmationModal buttonNegative="Cancel" buttonPositive="Change" title="Confirm Status Change" show={showDelete} body={"Are you sure want to change?"} onNegative={() => setShowDelete(false)}  /> */}
        {/* <ConfirmationModal buttonNegative="Cancel" buttonPositive="Delete" title="Delete Confirmation" show={showDelete} body={"Are you sure?"} onNegative={() => setShowDelete(false)} onPositive={handleServerDelete} /> */}
      </Card>
    </form>
  );
}

